module.exports = ".full-width {\n  width: 100%;\n  font-size: 14px;\n}\n.full-width > * {\n  width: 100%;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./Angular/app/_common/google-map/google-map.component.less
// module id = ./Angular/app/_common/google-map/google-map.component.less
// module chunks = main